import React, { useContext, useState } from "react";
import { useNavigate } from "react-router";
import UserContext from "Context/UserProvider";
import DashboardCard from '../common/DashboardCard';
import { Box, Typography, Button, Stack } from '@mui/material';
import HiveIcon from '@mui/icons-material/Hive';
import MapIcon from '@mui/icons-material/Map';

function ChargingNetwork(props: any) {
    const dashboardInfo = props.dashboardInfo;
    const { userInfo } = useContext(UserContext);
    const [isError] = useState(false);
    const navigate = useNavigate();
    const isPcn = props.pcn;
    const accentColor = props.accentColor;

    if (!isPcn) {
        console.log("isPcn", isPcn);
        return null;
    }

    return (
        <DashboardCard
            title="Charging Network"
            icon={<HiveIcon />}
            accentColor={accentColor}
            actions={
                <Button
                    startIcon={<MapIcon />}
                    onClick={() => navigate("/plan/private-charging-network/map")}
                >
                    View Network Map
                </Button>
            }
        >
            <Stack spacing={2}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body1" color="text.secondary">
                        Subscriptions:
                    </Typography>
                    <Typography variant="body1">
                        {dashboardInfo.businessesInPCN}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body1" color="text.secondary">
                        Virtual Charging Hubs:
                    </Typography>
                    <Typography variant="body1">
                        {dashboardInfo.countChargePointsInNetwork}
                    </Typography>
                </Box>
            </Stack>
        </DashboardCard>
    );
}

export default ChargingNetwork;
